import React from 'react';
import CommonToast from '@app/components/CommonToast';
import { DialogPop } from '@app/components/DialogPopup';
import { LoadingScreen } from '@app/components/Loading';
import { Outlet } from 'react-router-dom';

const EmptyLayout: React.FC = () => {
  return (
    <div className="empty-layout">
      <DialogPop />
      <CommonToast />
      <LoadingScreen />
      <Outlet />
    </div>
  );
};

export default EmptyLayout;
